import type { CSSProperties, ReactNode } from "react";
import { ak } from "./admin-styles";

// Settings-only admin pieces. The shared ones (PageHead, Section, Status,
// Banner, Tag, Toggle, Modal, Time) live in ~/components/editorial.

/** A strip of current counts with no prior period, for the identities page. */
export function LedgerRow({
  items,
}: {
  items: Array<{ label: string; value: ReactNode; note?: ReactNode }>;
}) {
  return (
    <dl
      className={ak.ledger}
      style={{ "--cols": items.length } as CSSProperties}
    >
      {items.map((item) => (
        <div key={item.label} className={ak.ledgerCell}>
          <dt>{item.label}</dt>
          <dd className={ak.ledgerValue}>{item.value}</dd>
          {item.note && <dd className={ak.ledgerNote}>{item.note}</dd>}
        </div>
      ))}
    </dl>
  );
}
